import React, { useCallback, useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import { ReimbursementMethodCard } from './ReimbursementMethodCard';
import {
  POLICY_STATUS,
  REIMBURSEMENT_METHODS,
} from '../../../constants';
import {
  useReimbursementScreen,
} from '../../myAccount/reimbursement/hooks/useReimbursementScreen';
import { MARKETING_CHANNEL_ID } from '../../../theme/theme.constants';
import { ViewMoreButton } from '../ViewMoreButton';

import styles from './Reimbursement.module.css';

export const Reimbursement = ({
  selectedPolicy = {},
}) => {
  const { t } = useTranslation('insurance');

  const {
    MarketChannelId,
    ReimbursementOption: {
      AccountNumberLastFour,
      CheckAddress,
      ReimbursementMethodId,
    },
    Status,
  } = selectedPolicy;

  const {
    onOpenReimbursementMethod,
  } = useReimbursementScreen({ breadCrumbs: null });

  const hasReimbursementMethod = useMemo(() => (ReimbursementMethodId
    !== REIMBURSEMENT_METHODS.none), [ReimbursementMethodId]);

  const isRedirectAvailable = useMemo(() => (
    Status === POLICY_STATUS.active
    || (Status === POLICY_STATUS.future
      && MarketChannelId === MARKETING_CHANNEL_ID.figo)
  ), [
    Status,
    MarketChannelId,
  ]);

  const handleReimbursementMethod = useCallback(() => {
    onOpenReimbursementMethod({
      policyInfo: selectedPolicy,
    });
  }, [selectedPolicy]);

  return (
    <div className={styles.reimbursementContainer}>
      <div className={styles.reimbursementHeader}>
        <div>
          <h3 className={styles.reimbursementTitle}>{t('reimbursement')}</h3>

          <span className={styles.reimbursementText}>
            {t('reimbursementText')}
          </span>
        </div>

        {hasReimbursementMethod && isRedirectAvailable && (
          <ViewMoreButton
            onClick={handleReimbursementMethod}
            text={t('reimbursementEdit')}
          />
        )}
      </div>

      <div className={styles.reimbursementContent}>
        <h5>{t('reimbursementMethod')}</h5>

        <ReimbursementMethodCard
          addressCheck={CheckAddress}
          isRedirectAvailable={isRedirectAvailable}
          lastNumbers={AccountNumberLastFour
            ?.substr(AccountNumberLastFour?.length - 4) || ''}
          methodType={ReimbursementMethodId}
          onReimbursementMethod={handleReimbursementMethod}
        />
      </div>
    </div>
  );
};
